export default {
		module:'OA模块1',
		code:'oa1',
		version:'1.0.0'
	}
	